import { createSlice } from '@reduxjs/toolkit';
export var RuleWorkspaceView;
(function (RuleWorkspaceView) {
    RuleWorkspaceView["Table"] = "table";
    RuleWorkspaceView["Calendar"] = "calendar";
})(RuleWorkspaceView || (RuleWorkspaceView = {}));
export var CalendarGranularity;
(function (CalendarGranularity) {
    CalendarGranularity["Month"] = "month";
    CalendarGranularity["Week"] = "week";
})(CalendarGranularity || (CalendarGranularity = {}));
const initialState = {
    view: RuleWorkspaceView.Table,
    granularity: CalendarGranularity.Month,
    anchorDate: Date.now(),
};
const ruleCalendarSlice = createSlice({
    name: 'ruleCalendar',
    initialState,
    reducers: {
        setRuleWorkspaceView: (state, action) => {
            state.view = action.payload;
        },
        setCalendarGranularity: (state, action) => {
            state.granularity = action.payload;
        },
        setCalendarAnchorDate: (state, action) => {
            state.anchorDate = action.payload;
        },
        goToToday: (state) => {
            state.anchorDate = Date.now();
        },
    },
});
export const { setRuleWorkspaceView, setCalendarGranularity, setCalendarAnchorDate, goToToday, } = ruleCalendarSlice.actions;
export default ruleCalendarSlice.reducer;
